import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { WBSButton } from '@/common/WBSButton';
import { DropdownArrow } from '~/styles/dropdownStyles';
import { NotificationCheckbox } from './NotificationCheckbox';

interface BulkActionsProps {
  allSelected: boolean;
  selectedCount: number;
  isReadView: boolean;
  onSelectAll: () => void;
  onApply: (action: string) => void;
}

export function BulkActions({
  allSelected,
  selectedCount,
  isReadView,
  onSelectAll,
  onApply,
}: BulkActionsProps) {
  const { t } = useTranslation();
  const [bulkAction, setBulkAction] = useState('');
  // Translation Needed
  const markLabel = isReadView ? t('wbs.mark-unread') : 'Mark Read';

  const handleApply = () => {
    if (bulkAction && selectedCount > 0) {
      onApply(bulkAction);
      setBulkAction('');
    }
  };

  return (
    <LeftSection>
      <NotificationCheckbox checked={allSelected} onChange={onSelectAll} />
      <ActionDropdownWrapper>
        <ActionDropdown
          value={bulkAction}
          onChange={(e) => setBulkAction(e.target.value)}
        >
          <option value="">{t('wbs.bulk-actions')}</option>
          <option value="mark-read-unread">{markLabel}</option>
          <option value="delete">{t('actions.delete')}</option>
        </ActionDropdown>
        <DropdownArrow>
          <FontAwesomeIcon icon={faChevronDown} />
        </DropdownArrow>
      </ActionDropdownWrapper>
      <WBSButton
        onClick={handleApply}
        disabled={!bulkAction || selectedCount === 0}
        wide
      >
        {/* Translation Needed */}
        Apply
      </WBSButton>
    </LeftSection>
  );
}

const LeftSection = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
`;

const ActionDropdownWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const ActionDropdown = styled.select`
  appearance: none;
  background: var(--white);
  border: 0;
  border-radius: 5px;
  box-shadow: var(--shadow-inset-lg);
  color: var(--black);
  font-family: var(--open-sans);
  font-size: 13px;
  font-weight: 400;
  outline: none;
  padding: 9px 12px;
  width: 130px;
`;
